import { SVGProps } from "react"

const NotAvailableIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z"
      stroke={props.color || "#C41407"}
      strokeMiterlimit="10"
    />
    <path
      d="M2.69531 2.69531L13.3047 13.3047"
      stroke={props.color || "#C41407"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default NotAvailableIcon
